module.exports = __webpack_public_path__ + "media/w1.70433ef6.webm";